export const getDateDifferenceInSeconds = (
  firstDate: number,
  secondDate: number
): number => {
  const differenceInMilliseconds = firstDate - secondDate;
  return Math.floor(differenceInMilliseconds / 1000);
};
